export default __webpack_public_path__ + "static/Aurora-9fde544cf51e3974f43cdfb2a8fc2998.png";